
// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, requestPaymentByProfessional } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitSavePaymentRequestJobAPi = createAsyncThunk("hitSavePaymentRequestJobAPi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("professionalToken")}`,
      },
    };
    const url = ApiBaseUrl + requestPaymentByProfessional;
    const response = await axios.post(url, payload, config);
    return response.data;
  } catch (error) {
    showToast(error.response.data.message, "error");
    throw error.response.data;
  }
});

const SavePaymentRequestJobSlice = createSlice({
  name: "savePaymentRequestJobReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitSavePaymentRequestJobData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSavePaymentRequestJobAPi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSavePaymentRequestJobAPi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitSavePaymentRequestJobAPi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitSavePaymentRequestJobData } = SavePaymentRequestJobSlice.actions;
export default SavePaymentRequestJobSlice.reducer;
